import {documentToReactComponents} from '@contentful/rich-text-react-renderer';

export const findSection = (internalName, sections) =>
  sections.find(section => section.internalName === internalName);

export const parseRichText = content =>
  documentToReactComponents(JSON.parse(content));
